import { CalendarDayEventBlockParams } from "../CalendarDayEventBlock/CalendarDayEventBlockParams.csharp";
import React from "react";
import { dateToTime } from "../../Components/Booking/Helpers";
import classNames from "classnames";

interface CalendarDayEventBlockProps extends CalendarDayEventBlockParams {
  whiteBg?: boolean;
}

export const CalendarDayEventBlock: React.FC<CalendarDayEventBlockProps> = ({
  isAvailable,
  time,
  type,
  owner,
  details,
  whiteBg = false,
}) => {
  const getFormattedHour = (time: Date) => dateToTime(time.toString());

  return (
    <li
      className={classNames("calendar-day-event-block p-1", {
        "calendar-day-event-block--whiteBg": whiteBg && isAvailable,
        "calendar-day-event-block--notAvailable": !isAvailable,
      })}
    >
      <h4
        className={classNames("mb-0", {
          "fw-normal": !isAvailable,
        })}
      >
        {getFormattedHour(time)} {type}
      </h4>
      <p className="m-0">{owner}</p>
      <p className="m-0 fst-italic">{details}</p>
    </li>
  );
};
